import type { Permission } from '@natashu/shared';

/** A requirement satisfied when the user holds at least one of the listed permissions. */
export type PermissionRequirement = Permission | readonly Permission[];

export function toList(req: PermissionRequirement): readonly Permission[] {
  return typeof req === 'string' ? [req] : req;
}

export function satisfies(granted: ReadonlySet<Permission>, req: PermissionRequirement | undefined): boolean {
  if (req === undefined) return true;
  const list = toList(req);
  return list.length === 0 || list.some((p) => granted.has(p));
}

export interface NavItemLike {
  anyOf: readonly Permission[];
}

export interface NavGroupLike<I extends NavItemLike> {
  items: readonly I[];
}

/** Drop items the user cannot use and groups left empty. The backend still enforces every call. */
export function visibleNavGroups<I extends NavItemLike, G extends NavGroupLike<I>>(groups: readonly G[], granted: ReadonlySet<Permission>): G[] {
  return groups
    .map((g) => ({ ...g, items: g.items.filter((i) => satisfies(granted, i.anyOf)) }))
    .filter((g) => g.items.length > 0);
}
